var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserReviewProfilImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_82_1629)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.84668,
    y: 0.364502,
    width: 45.6077,
    height: 45.6077,
    rx: 22.8038,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6544 23.8812C26.0118 23.8812 27.9301 21.9628 27.9301 19.6055V17.4676C27.9301 15.1103 26.0118 13.1919 23.6544 13.1919C22.5208 13.1932 21.434 13.644 20.6324 14.4456C19.8308 15.2472 19.38 16.334 19.3787 17.4676V19.6055C19.3787 21.9628 21.2971 23.8812 23.6544 23.8812Z",
    fill: "#F58634"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2175 26.0187H20.0913C18.3908 26.0202 16.7603 26.6964 15.5579 27.8989C14.3554 29.1013 13.6792 30.7317 13.6777 32.4323C13.6777 32.8256 13.997 33.1449 14.3904 33.1449H32.9185C33.1075 33.1449 33.2887 33.0698 33.4224 32.9362C33.556 32.8025 33.6311 32.6213 33.6311 32.4323C33.6296 30.7317 32.9534 29.1013 31.7509 27.8989C30.5485 26.6964 28.918 26.0202 27.2175 26.0187Z",
    fill: "#F58634"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_82_1629",
    x: -1.15332,
    y: 0.364502,
    width: 49.6074,
    height: 49.6077,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_82_1629"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_82_1629",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserReviewProfilImg);
export default __webpack_public_path__ + "static/media/userReviewProfilImg.4cf2a63242eaef746c6b689fd08c711b.svg";
export { ForwardRef as ReactComponent };